var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaSearchDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tablet buttons/lucide\xEF\xBD\x9Csearch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1665 3.33073C5.94484 3.33073 3.33317 5.9424 3.33317 9.16406C3.33317 12.3857 5.94484 14.9974 9.1665 14.9974C12.3882 14.9974 14.9998 12.3857 14.9998 9.16406C14.9998 5.9424 12.3882 3.33073 9.1665 3.33073ZM1.6665 9.16406C1.6665 5.02193 5.02437 1.66406 9.1665 1.66406C13.3086 1.66406 16.6665 5.02193 16.6665 9.16406C16.6665 10.9349 16.0528 12.5624 15.0264 13.8455L18.0891 16.9081C18.4145 17.2336 18.4145 17.7612 18.0891 18.0866C17.7637 18.4121 17.236 18.4121 16.9106 18.0866L13.8479 15.024C12.5649 16.0503 10.9374 16.6641 9.1665 16.6641C5.02437 16.6641 1.6665 13.3062 1.6665 9.16406Z",
    fill: "#FCFBFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaSearchDark);
export default __webpack_public_path__ + "static/media/figma-search-dark.45c629c05ab88ab81b617e08354c86ec.svg";
export { ForwardRef as ReactComponent };